import React from 'react';
const CollapseOpenCloseButton = ({ children }) => {
    return React.createElement("div", { id: 'open-close-button' }, children);
};
export default CollapseOpenCloseButton;
//# sourceMappingURL=index.js.map